import {
  GETList, 
  GETDetail,
  POSTWithToken,
  DELETEWithToken,
  PUTWithToken,
  GETAutoComplete,
} from "@/services/base-service";

const API_URL = "/api/position/v1";

export const getPosition = (values) => {
  const url = `${API_URL}/list`;
  return GETList(url, values);
};

export function createPosition(values) {
  const url = `${API_URL}/create`;
  return POSTWithToken(url, values);
}

export function getPositionAutoComplete(query, extra) {
  const url = `${API_URL}/autoComplete`;
  return GETAutoComplete(url, query, extra);
}

export function getPositionDetail(id) {
  return GETDetail(API_URL, id);
}

export function editPosition(values) {
  const { id } = values;
  const url = `${API_URL}/${id}`;
  return PUTWithToken(url, values);
}

export function archivePosition(id) {
  const url = `${API_URL}/${id}/soft`;
  return DELETEWithToken(url);
}

export function unarchivePosition(id) {
  const url = `${API_URL}/${id}/unarchive`;
  return PUTWithToken(url);
}

export function deletePosition(id) {
  const url = `${API_URL}/${id}`;
  return DELETEWithToken(url);
}